// copied from rheostat lib geometric
export default {
  getPosition(x, min, max) {
    return (max / (max - min)) ** 0.5 * ((x - min) / max) ** 0.5 * 100;
  },

  getValue(x, min, max) {
    return Math.round((x / 100) ** 2 * (max - min)) + min;
  }
};



// WEBPACK FOOTER //
// ./src/Scss/Custom/RheostatSlider/geometric.js